<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getReportPoSaless"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="filterCustomers" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Customer " id="filter-" size="sm" :model.sync="filter.filterCustomer" @input="getFilterCustomers" @focus="getFilterCustomers" />
					<app-input-combobox-autocomplete :options="filterDestinations" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Destination " id="filter-" size="sm" :model.sync="filter.filterDestination" @input="getFilterDestinations" @focus="getFilterDestinations" />
					<app-input-combobox-autocomplete :options="filterPartNos" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Part No " id="filter-" size="sm" :model.sync="filter.filterPartNo" @input="getFilterPartNos" @focus="getFilterPartNos" />
					</b-col>
					<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-filter-po-number" label-cols-sm="4" label-cols-lg="3" label="Po Number " label-for="filter-filter-po-number" size="sm" :model.sync="filter.filterPoNumber" />
					<app-input-datepicker-range  id="fieldset-filter-di-delivery-date" label-cols-sm="4" label-cols-lg="3" label="Di Delivery Date " size="sm" :modelFrom.sync="filter.filterDiDeliveryDateFrom" :modelTo.sync="filter.filterDiDeliveryDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					<app-input-combobox-autocomplete :options="filterStatusDeliverys" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Status Delivery " id="filter-" size="sm" :model.sync="filter.filterStatusDelivery" @input="getFilterStatusDeliverys" @focus="getFilterStatusDeliverys" />
					</b-col>
					<b-col cols="12" lg="6">

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getReportPoSaless"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
						   rounded
						   opacity="0.6"
						   spinner-small
						   spinner-variant="primary"
						   class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Report Po Sales</span>
				</b-col>
				<b-col>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download All To Excel</b-button>
					
					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table :stacked="isStacked" id="table-list-reportposales" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="light" :bordered="true" :no-local-sorting="true" :items="reportPoSaless" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="reportPoSaless.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
						<b-th stacked-heading="Customer" class="table-filter">
							<app-input-combobox-autocomplete @change="getReportPoSalessWithoutLoading" :options="filterCustomers" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Customer " id="filter-" size="sm" :model.sync="filter.filterCustomer" @input="getFilterCustomers" @focus="getFilterCustomers" />
							<!-- <b-form-input id="input-customer-name-table" @input="getReportPoSalessWithoutLoading" v-model="filter.customerName" size="sm"></b-form-input> -->
						</b-th>
						<b-th stacked-heading="Destination" class="table-filter">
							<app-input-combobox-autocomplete @change="getReportPoSalessWithoutLoading" :options="filterDestinations" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Destination " id="filter-" size="sm" :model.sync="filter.filterDestination" @input="getFilterDestinations" @focus="getFilterDestinations" />
							<!-- <b-form-input id="input-destination-name-table" @input="getReportPoSalessWithoutLoading" v-model="filter.destinationName" size="sm"></b-form-input> -->
						</b-th>
						<b-th stacked-heading="No Part" class="table-filter">
							<app-input-combobox-autocomplete @change="getReportPoSalessWithoutLoading" :options="filterPartNos" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Part No " id="filter-" size="sm" :model.sync="filter.filterPartNo" @input="getFilterPartNos" @focus="getFilterPartNos" />
							<!-- <b-form-input id="input-part-number-table" @input="getReportPoSalessWithoutLoading" v-model="filter.partNumber" size="sm"></b-form-input> -->
						</b-th>
						<b-th stacked-heading="Part Name" class="table-filter">
							<!-- <b-form-input id="input-part-name-table" @input="getReportPoSalessWithoutLoading" v-model="filter.partName" size="sm"></b-form-input> -->
						</b-th>
						<b-th stacked-heading="Delivery Date" class="table-filter">
							<app-input-datepicker-range  id="input-di-delivery-date" label="Di Delivery Date " size="sm" :modelFrom.sync="filter.filterDiDeliveryDateFrom" :modelTo.sync="filter.filterDiDeliveryDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button :nolabel="true" @change="getReportPoSalessWithoutLoading" />
						</b-th>
						<b-th stacked-heading="No PO" class="table-filter">
							<b-form-input id="input-po-no-customer-table" @input="getReportPoSalessWithoutLoading" v-model="filter.filterPoNumber" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Qty Planning" class="table-filter">
							<!-- <b-form-input id="input-qty-delivery-table" @input="getReportPoSalessWithoutLoading" v-model="filter.qtyDelivery" size="sm"></b-form-input> -->
						</b-th>
						<b-th stacked-heading="Qty Actual" class="table-filter">
							<!-- <b-form-input id="input-qty-actual-supply-table" @input="getReportPoSalessWithoutLoading" v-model="filter.qtyActualSupply" size="sm"></b-form-input> -->
						</b-th>
						<b-th stacked-heading="Balance" class="table-filter">
							<!-- <b-form-input id="input-balance-table" @input="getReportPoSalessWithoutLoading" v-model="filter.balance" size="sm"></b-form-input> -->
						</b-th>
						<b-th></b-th>
						<b-th stacked-heading="Amount" class="table-filter">
							<!-- <b-form-input id="input-amount-table" @input="getReportPoSalessWithoutLoading" v-model="filter.amount" size="sm"></b-form-input> -->
						</b-th>
						<b-th stacked-heading="Status Delivery" class="table-filter">
							<!-- <b-form-input id="input-status-delivery-table" @input="getReportPoSalessWithoutLoading" v-model="filter.statusDelivery" size="sm"></b-form-input> -->
							<app-input-combobox-autocomplete @change="getReportPoSalessWithoutLoading" :options="filterStatusDeliverys" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Status Delivery " id="filter-" size="sm" :model.sync="filter.filterStatusDelivery" @input="getFilterStatusDeliverys" @focus="getFilterStatusDeliverys" />
						</b-th>
					</template>

					<template #bottom-row>
						<b-th colspan="5">&nbsp;</b-th>
						<b-th>Total</b-th>
						<b-th><div class="input-label-currency">{{ Number(totalPlanning).toLocaleString() }}</div></b-th>
						<b-th><div class="input-label-currency">{{ Number(totalActual).toLocaleString() }}</div></b-th>
						<b-th colspan="4">&nbsp;</b-th>
					</template>

					<template v-slot:head(frontAction)>
						<div class="d-flex justify-content-center ml-2">
							<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right">
								<b-icon-funnel />
							</b-button>
						</div>
					</template>

					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(deliveryDate)="row">
						{{ row.item.deliveryDate | moment("DD-MMM-YYYY") }}
					</template>
					
					<template v-slot:cell(qtyDelivery)="row">
						<div class="input-label-currency">{{ Number(row.item.qtyDelivery).toLocaleString() }}</div>
					</template>
					<template v-slot:cell(qtyActualSupply)="row">
						<div class="input-label-currency">{{ Number(row.item.qtyActualSupply).toLocaleString() }}</div>
					</template>
					<template v-slot:cell(balance)="row">
						<div class="input-label-currency">{{ Number(row.item.balance).toLocaleString() }}</div>
					</template>
					<template v-slot:cell(priceProduct)="row">
						<div class="input-label-currency">{{ Number(row.item.priceProduct).toLocaleString() }}</div>
					</template>
					<template v-slot:cell(amount)="row">
						<div class="input-label-currency">{{ Number(row.item.amount).toLocaleString() }}</div>
					</template>

					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
							<app-input-textbox id="fieldset-part-number" label-cols-lg="12"  label="No Part" label-for="input-part-number" size="sm" :model.sync="row.item.partNumber"   :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-part-name" label-cols-lg="12"  label="Part Name" label-for="input-part-name" size="sm" :model.sync="row.item.partName"   :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-po-no-customer" label-cols-lg="12"  label="No PO" label-for="input-po-no-customer" size="sm" :model.sync="row.item.poNoCustomer"   :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-qty-delivery" label-cols-lg="12"  label="Qty Planning" label-for="input-qty-delivery" size="sm" :model.sync="row.item.qtyDelivery"   :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-qty-actual-supply" label-cols-lg="12"  label="Qty Actual" label-for="input-qty-actual-supply" size="sm" :model.sync="row.item.qtyActualSupply"   :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-balance" label-cols-lg="12"  label="Balance" label-for="input-balance" size="sm" :model.sync="row.item.balance"   :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-price-product" label-cols-lg="12"  label="Price Product" label-for="input-price-product" size="sm" :model.sync="row.item.priceProduct"  :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-amount" label-cols-lg="12"  label="Amount" label-for="input-amount" size="sm" :model.sync="row.item.amount"   :isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-status-delivery" label-cols-lg="12"  label="Status Delivery" label-for="input-status-delivery" size="sm" :model.sync="row.item.statusDelivery"   :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="d-flex justify-content-center">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
											  v-model="currentPage"
											  :total-rows="(reportPoSalessPaging != null ? reportPoSalessPaging.dataCount : 0)"
											  :per-page="(reportPoSalessPaging != null ? reportPoSalessPaging.pageSize : 0)"
											  aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
		<PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
		<RouterView />
	</div>
</template><style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    

    ::v-deep #table-list-reportposales.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

    ::v-deep #table-list-reportposales.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import ReportPoSales from '@/models/ReportPoSales/ReportPoSales';
import ReportPoSalesList from '@/models/ReportPoSales/ReportPoSalesList';
import ReportPoSalesFilter from '@/filters/ReportPoSales/ReportPoSalesFilter';
import RoleDetail from '@/models/Core/RoleDetail';
import moment from 'moment';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
export default {
	components : {
		ReportPoSales, 
		ReportPoSalesList, 
		ReportPoSalesFilter, 
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputTextbox,
		AppInputDatepicker,
		AppInputDatepickerRange,
		PopupDownload,
		PopupPDF,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"no" : {"class" : "th-number d-stack-none"}},
				{"frontAction" : {"class" : "th-number d-stack-none"}},
				{"customerName": {}, "class" : "th-customer-name first-child", "label" : "Customer", key: 'customerName', }, 
				{"destinationName": {}, "class" : "th-destination-name", "label" : "Destination", key: 'destinationName', }, 
				{"partNumber": {}, "class" : "th-part-number last-child", "label" : "No Part", key: 'partNumber', }, 
				{"partName": {}, "class" : "th-part-name d-stack-none", "label" : "Part Name", key: 'partName', }, 
				{"poNoCustomer": {}, "class" : "th-po-no-customer d-stack-none", "label" : "No PO", key: 'poNoCustomer', }, 
				{"deliveryDate": {}, "class" : "th-delivery-date d-stack-none", "label": "Delivery Date", key: 'deliveryDate' },
				{"qtyDelivery": {}, "class" : "th-qty-delivery d-stack-none", "label" : "Qty Planning", key: 'qtyDelivery', }, 
				{"qtyActualSupply": {}, "class" : "th-qty-actual-supply d-stack-none", "label" : "Qty Actual", key: 'qtyActualSupply', }, 
				{"balance": {}, "class" : "th-balance d-stack-none", "label" : "Balance", key: 'balance', },  
				{"priceProduct": {}, "class" : "th-price-product d-stack-none", "label" : "Price Product", key: 'priceProduct', }, 
				{"amount": {}, "class" : "th-amount d-stack-none", "label" : "Amount", key: 'amount', }, 
				{"statusDelivery": {}, "class" : "th-status-delivery d-stack-none", "label" : "Status Delivery", key: 'statusDelivery', }, 

			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			reportPoSaless: [],
			reportPoSalessPaging: {},
			filterCustomers : [],
			filterDestinations : [],
			filterPartNos : [],
			filterStatusDeliverys : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			totalPlanning: 0,
			totalActual: 0,
		}
	},	methods : {
		getReportPoSaless : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			let _this = this;
			this.totalPlanning = 0;
			this.totalActual = 0;
			ReportPoSales.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.reportPoSaless = result.data
					this.reportPoSalessPaging = result
					ReportPoSales.getListCustomUrl(_this, 'total', _this.filter, _this.sortingBy, (_this.currentPage - 1), _this.pageSizeOptions)
					.then(resultcount => {
						if (resultcount != null) {
							_this.totalPlanning = resultcount.data.totalPlanning;
							_this.totalActual = resultcount.data.totalActual;
						}
					});
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getReportPoSalessWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			let _this = this;
			this.totalPlanning = 0;
			this.totalActual = 0;
			ReportPoSales.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.reportPoSaless = result.data
					this.reportPoSalessPaging = result
					ReportPoSales.getListCustomUrl(_this, 'total', _this.sortingBy, (_this.currentPage - 1), _this.pageSizeOptions)
					.then(resultcount => {
						if (resultcount != null) {
							_this.totalPlanning = resultcount.data.totalPlanning;
							_this.totalActual = resultcount.data.totalActual;
						}
					});
				}
			})
			.catch(error => {});
		},
		getFilterCustomers : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			if(this.filter.filterCustomer != undefined && input == '')
			{
				console.log("masuk", this.filter.filterCustomer);
				filter.id = this.filter.filterCustomer;
			}
			console.log("filter", this.filter);

			await ReportPoSales.getListCustomUrl(this,'getlistfiltercustomer' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterCustomers = result.data
				}
			})
			.catch(error => {});
		},
		getFilterDestinations : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportPoSales.getListCustomUrl(this,'getlistfilterdestination' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterDestinations = result.data
				}
			})
			.catch(error => {});
		},
		getFilterPartNos : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportPoSales.getListCustomUrl(this,'getlistfilterpartno' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterPartNos = result.data
				}
			})
			.catch(error => {});
		},
		getFilterStatusDeliverys : async function(input) {
			let filter = new Object();
			if (input != undefined) {
				filter.name = input;
			}
			await ReportPoSales.getListCustomUrl(this,'getlistfilterstatusdelivery' ,filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.filterStatusDeliverys = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new ReportPoSalesFilter();
			this.getReportPoSaless();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getReportPoSaless();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				ReportPoSales.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			ReportPoSales.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			ReportPoSales.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},

		deleteData(id) {
			ReportPoSales.deleteData(this, id).then(result => {
				if (result)
				{
					this.getReportPoSaless();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				ReportPoSales.deleteMultipleData(this).then(result => {
					this.getReportPoSaless();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableReportPoSalesParent = document.getElementById('table-list-reportposales').parentNode;
			tableReportPoSalesParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableReportPoSalesParent.scrollWidth - tableReportPoSalesParent.offsetWidth) == Math.ceil(tableReportPoSalesParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableReportPoSalesParent = document.getElementById('table-list-reportposales').parentNode;
			tableReportPoSalesParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableReportPoSalesParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new ReportPoSalesFilter();
		this.getFilterCustomers()
		this.getFilterDestinations()
		this.getFilterPartNos()
		this.getFilterStatusDeliverys()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Report Po Sales"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getReportPoSaless();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getReportPoSaless();
			}
		},
		sortDesc: {
			handler: function() {
				this.getReportPoSaless();
			}
		},
		currentPage: {
			handler: function() {
				this.getReportPoSaless();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getReportPoSaless();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				ReportPoSales.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "reportposalesindex") {
					this.getReportPoSalessWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "report_po_sales").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
